var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      directives: [
        {
          name: "click-outside",
          rawName: "v-click-outside",
          value: () => {
            _vm.focused = false
          },
          expression: "() => { focused = false }",
        },
      ],
      ref: "input",
      class: {
        "c-input--container-active": _vm.containerActive,
      },
      attrs: { "data-type": _vm.type },
    },
    [
      _c(
        "div",
        {
          staticClass: "c-input",
          class: {
            "c-input--disabled": _vm.disabled,
          },
        },
        [
          _vm.label
            ? _c("div", { staticClass: "c-input-label" }, [
                _vm._v(" " + _vm._s(_vm.label) + " "),
                _vm.requiredMark
                  ? _c("span", { staticClass: "c-input-label__required" }, [
                      _vm._v("*"),
                    ])
                  : _vm._e(),
                _vm.labelFullName
                  ? _c(
                      "div",
                      { staticClass: "c-input-label-fullname" },
                      [
                        _c("c-button", {
                          directives: [
                            {
                              name: "b-popover",
                              rawName: "v-b-popover.html",
                              value: {
                                container: "#app",
                                trigger: "hover",
                                content: _vm.labelFullName,
                                placement: "bottom",
                              },
                              expression:
                                "{\n            container: '#app',\n            trigger: 'hover',\n            content: labelFullName,\n            placement: 'bottom',\n          }",
                              modifiers: { html: true },
                            },
                          ],
                          attrs: { size: "iconic", icon: "info" },
                        }),
                      ],
                      1
                    )
                  : _vm._e(),
              ])
            : _vm._e(),
          _vm.floatingLabel
            ? _c("div", { staticClass: "c-input-floating-label-not-visible" }, [
                _vm._v(" " + _vm._s(_vm.floatingLabel) + " "),
                _vm.requiredMark
                  ? _c("span", { staticClass: "c-input-label__required" }, [
                      _vm._v("*"),
                    ])
                  : _vm._e(),
                _vm.labelFullName
                  ? _c(
                      "div",
                      { staticClass: "c-input-label-fullname" },
                      [
                        _c("c-button", {
                          directives: [
                            {
                              name: "b-popover",
                              rawName: "v-b-popover.html",
                              value: {
                                container: "#app",
                                trigger: "hover",
                                content: _vm.labelFullName,
                                placement: "bottom",
                              },
                              expression:
                                "{\n            container: '#app',\n            trigger: 'hover',\n            content: labelFullName,\n            placement: 'bottom',\n          }",
                              modifiers: { html: true },
                            },
                          ],
                          attrs: { size: "iconic", icon: "info" },
                        }),
                      ],
                      1
                    )
                  : _vm._e(),
              ])
            : _vm._e(),
          _c("div", { staticClass: "c-input-wrapper" }, [
            _vm.prependArrow
              ? _c("span", { staticClass: "input-arrow" }, [_vm._v(" > ")])
              : _vm._e(),
            _vm.icon
              ? _c(
                  "div",
                  {
                    staticClass: "c-input-icon",
                    class: {
                      "c-input-icon_right": _vm.iconRight,
                      "c-input-icon_size_small": _vm.size === "small",
                    },
                  },
                  [
                    _vm.icon === "search"
                      ? _c(
                          "svg",
                          {
                            staticClass:
                              "c-input-icon-svg c-input-icon-svg_stroke",
                            attrs: {
                              width: "17",
                              height: "17",
                              viewBox: "0 0 17 17",
                              xmlns: "http://www.w3.org/2000/svg",
                            },
                          },
                          [
                            _c("path", {
                              attrs: {
                                d: "M11.4142 11L15.6569 15.2426M13 7C13 10.3137 10.3137 13 7 13C3.68629 13 1 10.3137 1 7C1 3.68629 3.68629 1 7 1C10.3137 1 13 3.68629 13 7Z",
                                "stroke-width": "2",
                                "stroke-linecap": "round",
                              },
                            }),
                          ]
                        )
                      : _vm._e(),
                    _vm.icon === "calendar"
                      ? _c(
                          "svg",
                          {
                            staticClass: "c-input-icon-calendar",
                            attrs: {
                              width: "18",
                              height: "18",
                              viewBox: "0 0 18 18",
                              fill: "none",
                              xmlns: "http://www.w3.org/2000/svg",
                            },
                            on: {
                              click: function ($event) {
                                return _vm.openContainer()
                              },
                            },
                          },
                          [
                            _c("path", {
                              attrs: {
                                d: "M15.2222 3H2.77778C1.79594 3 1 3.69645 1 4.55556V15.4444C1 16.3036 1.79594 17 2.77778 17H15.2222C16.2041 17 17 16.3036 17 15.4444V4.55556C17 3.69645 16.2041 3 15.2222 3Z",
                                stroke: "#8E9CBB",
                                "stroke-width": "2",
                                "stroke-linecap": "round",
                                "stroke-linejoin": "round",
                              },
                            }),
                            _c("path", {
                              attrs: {
                                d: "M13 1V5",
                                stroke: "#8E9CBB",
                                "stroke-width": "2",
                                "stroke-linecap": "round",
                                "stroke-linejoin": "round",
                              },
                            }),
                            _c("path", {
                              attrs: {
                                d: "M5 1V5",
                                stroke: "#8E9CBB",
                                "stroke-width": "2",
                                "stroke-linecap": "round",
                                "stroke-linejoin": "round",
                              },
                            }),
                            _c("rect", {
                              attrs: {
                                x: "4",
                                y: "8",
                                width: "2",
                                height: "2",
                                fill: "#8E9CBB",
                              },
                            }),
                            _c("rect", {
                              attrs: {
                                x: "4",
                                y: "12",
                                width: "2",
                                height: "2",
                                fill: "#8E9CBB",
                              },
                            }),
                            _c("rect", {
                              attrs: {
                                x: "8",
                                y: "8",
                                width: "2",
                                height: "2",
                                fill: "#8E9CBB",
                              },
                            }),
                            _c("rect", {
                              attrs: {
                                x: "8",
                                y: "12",
                                width: "2",
                                height: "2",
                                fill: "#8E9CBB",
                              },
                            }),
                            _c("rect", {
                              attrs: {
                                x: "12",
                                y: "8",
                                width: "2",
                                height: "2",
                                fill: "#8E9CBB",
                              },
                            }),
                            _c("rect", {
                              attrs: {
                                x: "12",
                                y: "12",
                                width: "2",
                                height: "2",
                                fill: "#8E9CBB",
                              },
                            }),
                          ]
                        )
                      : _vm._e(),
                  ]
                )
              : _vm._e(),
            _vm.type === "password"
              ? _c(
                  "div",
                  {
                    staticClass:
                      "c-input-icon c-input-icon_right cursor-pointer",
                    on: {
                      click: function ($event) {
                        _vm.passwordVisible = !_vm.passwordVisible
                      },
                    },
                  },
                  [
                    _vm.passwordVisible
                      ? _c(
                          "svg",
                          {
                            attrs: {
                              width: "20",
                              height: "13",
                              viewBox: "0 0 20 13",
                              fill: "none",
                              xmlns: "http://www.w3.org/2000/svg",
                            },
                          },
                          [
                            _c("path", {
                              attrs: {
                                d: "M5.70711 0.292893C5.31658 -0.0976311 4.68342 -0.0976311 4.29289 0.292893C3.90237 0.683417 3.90237 1.31658 4.29289 1.70711L5.70711 0.292893ZM15.2929 12.7071C15.6834 13.0976 16.3166 13.0976 16.7071 12.7071C17.0976 12.3166 17.0976 11.6834 16.7071 11.2929L15.2929 12.7071ZM18 7L18.8129 7.58235L19.2301 7L18.8129 6.41765L18 7ZM2 7L1.18706 6.41765L0.769899 7L1.18706 7.58235L2 7ZM4.29289 1.70711L15.2929 12.7071L16.7071 11.2929L5.70711 0.292893L4.29289 1.70711ZM18 7C17.1871 6.41765 17.1872 6.41744 17.1874 6.41725C17.1874 6.41721 17.1875 6.41703 17.1876 6.41695C17.1877 6.41679 17.1877 6.41671 17.1877 6.4167C17.1878 6.41668 17.1876 6.41696 17.1871 6.41753C17.1863 6.41867 17.1846 6.42098 17.1821 6.42442C17.1771 6.4313 17.1687 6.4427 17.1571 6.45831C17.1338 6.48955 17.0975 6.5376 17.0488 6.60008C16.9513 6.72511 16.8048 6.90733 16.6145 7.12764C16.2328 7.56963 15.6814 8.15767 15.0033 8.7431C13.6162 9.94076 11.847 11 10 11V13C12.5713 13 14.8021 11.5592 16.3104 10.2569C17.0801 9.59233 17.7002 8.93037 18.1281 8.43486C18.3427 8.18642 18.5105 7.97801 18.6262 7.82961C18.684 7.75537 18.729 7.696 18.7603 7.654C18.776 7.63299 18.7882 7.61631 18.797 7.60427C18.8014 7.59825 18.805 7.59339 18.8076 7.58972C18.809 7.58789 18.8101 7.58635 18.8109 7.58512C18.8114 7.58451 18.8118 7.58397 18.8121 7.5835C18.8123 7.58327 18.8125 7.58298 18.8126 7.58287C18.8128 7.5826 18.8129 7.58235 18 7ZM10 11C8.15301 11 6.38378 9.94076 4.99668 8.7431C4.31864 8.15767 3.76722 7.56963 3.38551 7.12764C3.19525 6.90733 3.0487 6.72511 2.95124 6.60008C2.90254 6.5376 2.86621 6.48955 2.84292 6.45831C2.83127 6.4427 2.82289 6.4313 2.81787 6.42442C2.81535 6.42098 2.81368 6.41867 2.81286 6.41753C2.81244 6.41696 2.81224 6.41668 2.81226 6.4167C2.81226 6.41671 2.81232 6.41679 2.81244 6.41695C2.81249 6.41703 2.81262 6.41721 2.81265 6.41725C2.81279 6.41744 2.81294 6.41765 2 7C1.18706 7.58235 1.18724 7.5826 1.18743 7.58287C1.18752 7.58298 1.18772 7.58327 1.18789 7.5835C1.18822 7.58397 1.18861 7.58451 1.18905 7.58512C1.18994 7.58635 1.19104 7.58789 1.19237 7.58972C1.19502 7.59339 1.19855 7.59825 1.20295 7.60427C1.21175 7.61631 1.22402 7.63299 1.23969 7.654C1.27102 7.696 1.31595 7.75537 1.37382 7.82961C1.4895 7.97801 1.65729 8.18642 1.87185 8.43486C2.29978 8.93037 2.91993 9.59233 3.68962 10.2569C5.19795 11.5592 7.42871 13 10 13V11ZM2 7C2.81294 7.58235 2.81279 7.58256 2.81265 7.58275C2.81262 7.58279 2.81249 7.58297 2.81244 7.58305C2.81232 7.58321 2.81226 7.58329 2.81226 7.5833C2.81224 7.58332 2.81244 7.58304 2.81286 7.58247C2.81368 7.58133 2.81535 7.57902 2.81787 7.57558C2.82289 7.5687 2.83127 7.5573 2.84292 7.54169C2.86621 7.51045 2.90254 7.4624 2.95124 7.39992C3.0487 7.27489 3.19525 7.09267 3.38551 6.87236C3.76722 6.43037 4.31864 5.84233 4.99668 5.2569C6.38378 4.05924 8.15301 3 10 3V1C7.42871 1 5.19795 2.44076 3.68962 3.7431C2.91993 4.40767 2.29978 5.06963 1.87185 5.56514C1.65729 5.81358 1.4895 6.02199 1.37382 6.17039C1.31595 6.24463 1.27102 6.304 1.23969 6.346C1.22402 6.36701 1.21175 6.38369 1.20295 6.39573C1.19855 6.40175 1.19502 6.40661 1.19237 6.41028C1.19104 6.41211 1.18994 6.41365 1.18905 6.41488C1.18861 6.41549 1.18822 6.41603 1.18789 6.4165C1.18772 6.41673 1.18752 6.41702 1.18743 6.41713C1.18724 6.4174 1.18706 6.41765 2 7ZM10 3C11.847 3 13.6162 4.05924 15.0033 5.2569C15.6814 5.84233 16.2328 6.43037 16.6145 6.87236C16.8048 7.09267 16.9513 7.27489 17.0488 7.39992C17.0975 7.4624 17.1338 7.51045 17.1571 7.54169C17.1687 7.5573 17.1771 7.5687 17.1821 7.57558C17.1846 7.57902 17.1863 7.58133 17.1871 7.58247C17.1876 7.58304 17.1878 7.58332 17.1877 7.5833C17.1877 7.58329 17.1877 7.58321 17.1876 7.58305C17.1875 7.58297 17.1874 7.58279 17.1874 7.58275C17.1872 7.58256 17.1871 7.58235 18 7C18.8129 6.41765 18.8128 6.4174 18.8126 6.41713C18.8125 6.41702 18.8123 6.41673 18.8121 6.4165C18.8118 6.41603 18.8114 6.41549 18.8109 6.41488C18.8101 6.41365 18.809 6.41211 18.8076 6.41028C18.805 6.40661 18.8014 6.40175 18.797 6.39573C18.7882 6.38369 18.776 6.36701 18.7603 6.346C18.729 6.304 18.684 6.24463 18.6262 6.17039C18.5105 6.02199 18.3427 5.81358 18.1281 5.56514C17.7002 5.06963 17.0801 4.40767 16.3104 3.7431C14.8021 2.44076 12.5713 1 10 1V3ZM12 6C12 7.10457 11.1046 8 10 8V10C12.2091 10 14 8.20914 14 6H12ZM10 8C8.89543 8 8 7.10457 8 6H6C6 8.20914 7.79086 10 10 10V8ZM8 6C8 4.89543 8.89543 4 10 4V2C7.79086 2 6 3.79086 6 6H8ZM10 4C11.1046 4 12 4.89543 12 6H14C14 3.79086 12.2091 2 10 2V4Z",
                                fill: "#8E9CBB",
                              },
                            }),
                          ]
                        )
                      : _c(
                          "svg",
                          {
                            staticClass: "c-input-icon-svg",
                            attrs: {
                              width: "20",
                              height: "12",
                              viewBox: "0 0 20 12",
                              fill: "none",
                              xmlns: "http://www.w3.org/2000/svg",
                            },
                          },
                          [
                            _c("path", {
                              attrs: {
                                d: "M18 6C18 6 14.4183 11 10 11C5.58172 11 2 6 2 6C2 6 5.58172 1 10 1C14.4183 1 18 6 18 6Z",
                                stroke: "#8E9CBB",
                                "stroke-width": "2",
                              },
                            }),
                            _c("path", {
                              attrs: {
                                d: "M13 5C13 6.65685 11.6569 8 10 8C8.34315 8 7 6.65685 7 5C7 3.34315 8.34315 2 10 2C11.6569 2 13 3.34315 13 5Z",
                                stroke: "#8E9CBB",
                                "stroke-width": "2",
                              },
                            }),
                          ]
                        ),
                  ]
                )
              : _vm._e(),
            _vm.displaySelectDatePeriodInput
              ? _c(
                  "div",
                  {
                    staticClass: "c-input-value",
                    class: {
                      "c-input-value_type_select": _vm.type === "select",
                      "c-input-value_placeholder": !_vm.selectValue,
                      "c-input-value_type_select_clearable": _vm.clearable,
                      "c-input-value_type_select_multiple": _vm.multiple,
                      "c-input-value_size_small": _vm.size === "small",
                      "c-input-value_type_select_multiple_with_icon":
                        _vm.multiple && _vm.checkboxType === "icon",
                      "c-input-value_type_select_multiple_without_checkbox":
                        !_vm.checkbox && _vm.multiple,
                    },
                    on: { click: _vm.openContainer },
                  },
                  [
                    !_vm.multiple &&
                    !_vm.withCategorized &&
                    _vm.type === "select"
                      ? _c("div", { staticClass: "c-input-value-single" }, [
                          _c("span", {
                            domProps: {
                              innerHTML: _vm._s(
                                _vm.selectValue
                                  ? _vm.selectValue.resultLabel ||
                                      _vm.selectValue.label ||
                                      _vm.getLabel(_vm.selectValue)
                                  : _vm.placeholder
                              ),
                            },
                          }),
                        ])
                      : _vm._e(),
                    !_vm.multiple &&
                    _vm.withCategorized &&
                    _vm.type === "select"
                      ? _c("div", { staticClass: "c-input-value-single" }, [
                          _c("span", {
                            domProps: {
                              innerHTML: _vm._s(
                                _vm.selectValue
                                  ? _vm.selectValue.resultLabel ||
                                      _vm.selectValue.formatLabel ||
                                      _vm.getLabel(_vm.selectValue)
                                  : _vm.placeholder
                              ),
                            },
                          }),
                        ])
                      : _vm._e(),
                    _vm.multiple
                      ? _c(
                          "div",
                          { staticClass: "c-input-value-multiple" },
                          [
                            !_vm.selectValue || _vm.selectValue.length === 0
                              ? _c(
                                  "div",
                                  {
                                    staticClass: "c-input-value-placeholder",
                                    class: {
                                      "c-input-value-placeholder-small":
                                        _vm.size === "small",
                                    },
                                  },
                                  [_vm._v(" " + _vm._s(_vm.placeholder) + " ")]
                                )
                              : _vm._e(),
                            _vm._l(
                              _vm.selectValue,
                              function (selectValueItem, selectValueItemIndex) {
                                return _c(
                                  "div",
                                  {
                                    key: selectValueItem.value,
                                    staticClass: "c-input-value-multiple-item",
                                  },
                                  [
                                    _c("div", {
                                      staticClass:
                                        "c-input-value-multiple-item-text",
                                      domProps: {
                                        innerHTML: _vm._s(
                                          selectValueItem.resultLabel ||
                                            selectValueItem.formatLabel ||
                                            selectValueItem.label ||
                                            _vm.getLabel(selectValueItem)
                                        ),
                                      },
                                    }),
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "c-input-value-multiple-item-close",
                                      },
                                      [
                                        _c(
                                          "svg",
                                          {
                                            attrs: {
                                              width: "12",
                                              height: "12",
                                              viewBox: "0 0 12 12",
                                              xmlns:
                                                "http://www.w3.org/2000/svg",
                                            },
                                            on: {
                                              click: (e) =>
                                                _vm.dropItem(
                                                  e,
                                                  selectValueItemIndex
                                                ),
                                            },
                                          },
                                          [
                                            _c("path", {
                                              attrs: {
                                                d: "M0.325608 10.746C-0.0649162 10.3555 -0.0649162 9.72233 0.325608 9.33181L9.36312 0.292893C9.75364 -0.0976313 10.3868 -0.0976309 10.7773 0.292893C11.1679 0.683418 11.1679 1.31658 10.7773 1.70711L1.73982 10.746C1.3493 11.1365 0.716132 11.1365 0.325608 10.746Z",
                                              },
                                            }),
                                            _c("path", {
                                              attrs: {
                                                d: "M10.6836 10.6835C11.0741 10.293 11.0741 9.65986 10.6836 9.26933L1.70711 0.292893C1.31658 -0.0976313 0.683417 -0.0976309 0.292893 0.292893C-0.0976311 0.683418 -0.0976311 1.31658 0.292893 1.70711L9.26935 10.6835C9.65987 11.0741 10.293 11.0741 10.6836 10.6835Z",
                                              },
                                            }),
                                          ]
                                        ),
                                      ]
                                    ),
                                  ]
                                )
                              }
                            ),
                          ],
                          2
                        )
                      : _vm._e(),
                    (_vm.type === "date" && !_vm.editable) ||
                    _vm.type === "period" ||
                    _vm.type === "period-without-fixed-intervals"
                      ? _c(
                          "div",
                          {
                            staticClass: "c-input-value-date",
                            class: {
                              "c-input-value-date_placeholder": !_vm.dateValue,
                              "c-input-value-date_size_small":
                                _vm.size === "small",
                            },
                          },
                          [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.dateValue
                                    ? _vm.dateValue
                                    : _vm.placeholder
                                ) +
                                " "
                            ),
                          ]
                        )
                      : _vm._e(),
                  ]
                )
              : _vm._e(),
            (_vm.type === "password" && !_vm.passwordVisible
              ? "password"
              : "text") === "checkbox" &&
            (!_vm.type || _vm.type === "text" || _vm.type === "password") &&
            !_vm.mask &&
            _vm.type !== "number"
              ? _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.textValue,
                      expression: "textValue",
                    },
                  ],
                  ref: "text-input-element",
                  staticClass: "c-input-input",
                  class: {
                    "c-input-input_placeholder_italic":
                      _vm.placeholderStyle === "italic",
                    "c-input-input_size_small": _vm.size === "small",
                    "c-input-input-with-copy-to-clipboard":
                      _vm.copiedToClipboard,
                    "c-input-input_floating_label_active":
                      _vm.textValue && _vm.floatingLabel,
                  },
                  attrs: {
                    autocomplete:
                      _vm.type === "password" ? "new-password" : "off",
                    maxlength: _vm.maxLength && Number(_vm.maxLength),
                    disabled: _vm.disabled || _vm.type === "select",
                    placeholder: _vm.placeholder,
                    pattern: _vm.pattern,
                    type: "checkbox",
                  },
                  domProps: {
                    checked: Array.isArray(_vm.textValue)
                      ? _vm._i(_vm.textValue, null) > -1
                      : _vm.textValue,
                  },
                  on: {
                    keydown: _vm.handleInputTextKeypressed,
                    keypress: _vm.handleInputTextKeypressed,
                    focus: _vm.handleInputFocus,
                    focusout: function ($event) {
                      _vm.focused = false
                    },
                    change: function ($event) {
                      var $$a = _vm.textValue,
                        $$el = $event.target,
                        $$c = $$el.checked ? true : false
                      if (Array.isArray($$a)) {
                        var $$v = null,
                          $$i = _vm._i($$a, $$v)
                        if ($$el.checked) {
                          $$i < 0 && (_vm.textValue = $$a.concat([$$v]))
                        } else {
                          $$i > -1 &&
                            (_vm.textValue = $$a
                              .slice(0, $$i)
                              .concat($$a.slice($$i + 1)))
                        }
                      } else {
                        _vm.textValue = $$c
                      }
                    },
                  },
                })
              : (_vm.type === "password" && !_vm.passwordVisible
                  ? "password"
                  : "text") === "radio" &&
                (!_vm.type || _vm.type === "text" || _vm.type === "password") &&
                !_vm.mask &&
                _vm.type !== "number"
              ? _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.textValue,
                      expression: "textValue",
                    },
                  ],
                  ref: "text-input-element",
                  staticClass: "c-input-input",
                  class: {
                    "c-input-input_placeholder_italic":
                      _vm.placeholderStyle === "italic",
                    "c-input-input_size_small": _vm.size === "small",
                    "c-input-input-with-copy-to-clipboard":
                      _vm.copiedToClipboard,
                    "c-input-input_floating_label_active":
                      _vm.textValue && _vm.floatingLabel,
                  },
                  attrs: {
                    autocomplete:
                      _vm.type === "password" ? "new-password" : "off",
                    maxlength: _vm.maxLength && Number(_vm.maxLength),
                    disabled: _vm.disabled || _vm.type === "select",
                    placeholder: _vm.placeholder,
                    pattern: _vm.pattern,
                    type: "radio",
                  },
                  domProps: { checked: _vm._q(_vm.textValue, null) },
                  on: {
                    keydown: _vm.handleInputTextKeypressed,
                    keypress: _vm.handleInputTextKeypressed,
                    focus: _vm.handleInputFocus,
                    focusout: function ($event) {
                      _vm.focused = false
                    },
                    change: function ($event) {
                      _vm.textValue = null
                    },
                  },
                })
              : (!_vm.type || _vm.type === "text" || _vm.type === "password") &&
                !_vm.mask &&
                _vm.type !== "number"
              ? _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.textValue,
                      expression: "textValue",
                    },
                  ],
                  ref: "text-input-element",
                  staticClass: "c-input-input",
                  class: {
                    "c-input-input_placeholder_italic":
                      _vm.placeholderStyle === "italic",
                    "c-input-input_size_small": _vm.size === "small",
                    "c-input-input-with-copy-to-clipboard":
                      _vm.copiedToClipboard,
                    "c-input-input_floating_label_active":
                      _vm.textValue && _vm.floatingLabel,
                  },
                  attrs: {
                    autocomplete:
                      _vm.type === "password" ? "new-password" : "off",
                    maxlength: _vm.maxLength && Number(_vm.maxLength),
                    disabled: _vm.disabled || _vm.type === "select",
                    placeholder: _vm.placeholder,
                    pattern: _vm.pattern,
                    type:
                      _vm.type === "password" && !_vm.passwordVisible
                        ? "password"
                        : "text",
                  },
                  domProps: { value: _vm.textValue },
                  on: {
                    keydown: _vm.handleInputTextKeypressed,
                    keypress: _vm.handleInputTextKeypressed,
                    focus: _vm.handleInputFocus,
                    focusout: function ($event) {
                      _vm.focused = false
                    },
                    input: function ($event) {
                      if ($event.target.composing) return
                      _vm.textValue = $event.target.value
                    },
                  },
                })
              : _vm._e(),
            (_vm.type === undefined ? "text" : "text") === "checkbox" &&
            _vm.mask &&
            _vm.type !== "number"
              ? _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.textValue,
                      expression: "textValue",
                    },
                    {
                      name: "mask",
                      rawName: "v-mask",
                      value: _vm.mask,
                      expression: "mask",
                    },
                  ],
                  staticClass: "c-input-input",
                  class: {
                    "c-input-input_placeholder_italic":
                      _vm.placeholderStyle === "italic",
                    "c-input-input_size_small": _vm.size === "small",
                  },
                  attrs: {
                    disabled: _vm.type === "select",
                    placeholder: _vm.placeholder,
                    type: "checkbox",
                  },
                  domProps: {
                    checked: Array.isArray(_vm.textValue)
                      ? _vm._i(_vm.textValue, null) > -1
                      : _vm.textValue,
                  },
                  on: {
                    focus: function ($event) {
                      _vm.focused = true
                    },
                    focusout: function ($event) {
                      _vm.focused = false
                    },
                    change: function ($event) {
                      var $$a = _vm.textValue,
                        $$el = $event.target,
                        $$c = $$el.checked ? true : false
                      if (Array.isArray($$a)) {
                        var $$v = null,
                          $$i = _vm._i($$a, $$v)
                        if ($$el.checked) {
                          $$i < 0 && (_vm.textValue = $$a.concat([$$v]))
                        } else {
                          $$i > -1 &&
                            (_vm.textValue = $$a
                              .slice(0, $$i)
                              .concat($$a.slice($$i + 1)))
                        }
                      } else {
                        _vm.textValue = $$c
                      }
                    },
                  },
                })
              : (_vm.type === undefined ? "text" : "text") === "radio" &&
                _vm.mask &&
                _vm.type !== "number"
              ? _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.textValue,
                      expression: "textValue",
                    },
                    {
                      name: "mask",
                      rawName: "v-mask",
                      value: _vm.mask,
                      expression: "mask",
                    },
                  ],
                  staticClass: "c-input-input",
                  class: {
                    "c-input-input_placeholder_italic":
                      _vm.placeholderStyle === "italic",
                    "c-input-input_size_small": _vm.size === "small",
                  },
                  attrs: {
                    disabled: _vm.type === "select",
                    placeholder: _vm.placeholder,
                    type: "radio",
                  },
                  domProps: { checked: _vm._q(_vm.textValue, null) },
                  on: {
                    focus: function ($event) {
                      _vm.focused = true
                    },
                    focusout: function ($event) {
                      _vm.focused = false
                    },
                    change: function ($event) {
                      _vm.textValue = null
                    },
                  },
                })
              : _vm.mask && _vm.type !== "number"
              ? _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.textValue,
                      expression: "textValue",
                    },
                    {
                      name: "mask",
                      rawName: "v-mask",
                      value: _vm.mask,
                      expression: "mask",
                    },
                  ],
                  staticClass: "c-input-input",
                  class: {
                    "c-input-input_placeholder_italic":
                      _vm.placeholderStyle === "italic",
                    "c-input-input_size_small": _vm.size === "small",
                  },
                  attrs: {
                    disabled: _vm.type === "select",
                    placeholder: _vm.placeholder,
                    type: _vm.type === undefined ? "text" : "text",
                  },
                  domProps: { value: _vm.textValue },
                  on: {
                    focus: function ($event) {
                      _vm.focused = true
                    },
                    focusout: function ($event) {
                      _vm.focused = false
                    },
                    input: function ($event) {
                      if ($event.target.composing) return
                      _vm.textValue = $event.target.value
                    },
                  },
                })
              : _vm._e(),
            _vm.type === "number"
              ? _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model.number",
                      value: _vm.textValue,
                      expression: "textValue",
                      modifiers: { number: true },
                    },
                  ],
                  staticClass: "c-input-input c-input-input_type_number",
                  class: {
                    "c-input-input_placeholder_italic":
                      _vm.placeholderStyle === "italic",
                    "c-input-input_size_small": _vm.size === "small",
                  },
                  attrs: {
                    type: "number",
                    placeholder: _vm.placeholder,
                    pattern: _vm.pattern,
                    maxlength: _vm.maxLength && Number(_vm.maxLength),
                  },
                  domProps: { value: _vm.textValue },
                  on: {
                    keypress: _vm.handleInputNumberKeypressed,
                    focus: function ($event) {
                      _vm.focused = true
                    },
                    focusout: function ($event) {
                      _vm.focused = false
                    },
                    input: function ($event) {
                      if ($event.target.composing) return
                      _vm.textValue = _vm._n($event.target.value)
                    },
                    blur: function ($event) {
                      return _vm.$forceUpdate()
                    },
                  },
                })
              : _vm._e(),
            _vm.type === "price-number"
              ? _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.textValue,
                      expression: "textValue",
                    },
                  ],
                  staticClass: "c-input-input c-input-input_type_number",
                  class: {
                    "c-input-input_placeholder_italic":
                      _vm.placeholderStyle === "italic",
                    "c-input-input_size_small": _vm.size === "small",
                    "c-input-input_floating_label_active":
                      "" + _vm.textValue && _vm.floatingLabel,
                  },
                  attrs: {
                    maxlength: _vm.maxLength && Number(_vm.maxLength),
                    type: "text",
                    placeholder: _vm.placeholder,
                  },
                  domProps: { value: _vm.textValue },
                  on: {
                    keypress: _vm.handleInputPriceKeypressed,
                    focus: function ($event) {
                      _vm.focused = true
                    },
                    focusout: function ($event) {
                      _vm.focused = false
                    },
                    input: function ($event) {
                      if ($event.target.composing) return
                      _vm.textValue = $event.target.value
                    },
                  },
                })
              : _vm._e(),
            _vm.type === "integer-number"
              ? _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.textValue,
                      expression: "textValue",
                    },
                  ],
                  staticClass: "c-input-input c-input-input_type_number",
                  class: {
                    "c-input-input_placeholder_italic":
                      _vm.placeholderStyle === "italic",
                    "c-input-input_size_small": _vm.size === "small",
                    "c-input-input_floating_label_active":
                      "" + _vm.textValue && _vm.floatingLabel,
                    "ml-22": _vm.prependArrow,
                  },
                  attrs: {
                    type: "number",
                    maxlength: _vm.maxLength && Number(_vm.maxLength),
                    placeholder: _vm.placeholder,
                  },
                  domProps: { value: _vm.textValue },
                  on: {
                    paste: function ($event) {
                      $event.preventDefault()
                    },
                    keypress: _vm.handleInputIntegerNumberKeypressed,
                    focus: function ($event) {
                      _vm.focused = true
                    },
                    focusout: function ($event) {
                      _vm.focused = false
                    },
                    input: function ($event) {
                      if ($event.target.composing) return
                      _vm.textValue = $event.target.value
                    },
                  },
                })
              : _vm._e(),
            _vm.type === "textarea"
              ? _c(
                  "div",
                  {
                    staticClass: "c-input-textarea c-input-input",
                    class: { "c-input-textarea-clearable": _vm.clearable },
                    style: { "max-height": `${_vm.textareaMaxHeight}px` },
                  },
                  [
                    _c("div", {
                      ref: "textareaValue",
                      staticClass: "c-input-textarea-value",
                      style: {
                        "max-height": `${_vm.textareaMaxHeight}px`,
                        overflow: "hidden",
                      },
                      attrs: { contenteditable: "" },
                      on: {
                        focus: function ($event) {
                          _vm.focused = true
                        },
                        focusout: function ($event) {
                          _vm.focused = false
                        },
                        keydown: _vm.checkTextareaInputSize,
                        paste: _vm.checkTextareaInputSize,
                        input: _vm.onInput,
                      },
                    }),
                    _vm.textValue === ""
                      ? _c(
                          "div",
                          { staticClass: "c-input-textarea-placeholder" },
                          [_vm._v(" " + _vm._s(_vm.placeholder) + " ")]
                        )
                      : _vm._e(),
                  ]
                )
              : _vm._e(),
            _vm.floatingLabel
              ? _c(
                  "div",
                  {
                    staticClass: "c-input-floating-label",
                    class: {
                      "c-input-floating-label-active":
                        (_vm.isArray(_vm.selectValue) &&
                          _vm.selectValue.length !== 0) ||
                        (!_vm.isArray(_vm.selectValue) && _vm.selectValue) ||
                        (_vm.type === "textarea" &&
                          (_vm.focused || _vm.textValue)),
                      "c-input-floating-label-pr":
                        !_vm.multiple && !_vm.container,
                    },
                  },
                  [
                    _vm._v(" " + _vm._s(_vm.floatingLabel) + " "),
                    _vm.requiredMark
                      ? _c("span", { staticClass: "c-input-label__required" }, [
                          _vm._v("*"),
                        ])
                      : _vm._e(),
                    _vm.labelFullName
                      ? _c(
                          "div",
                          { staticClass: "c-input-label-fullname" },
                          [
                            _c("c-button", {
                              directives: [
                                {
                                  name: "b-popover",
                                  rawName: "v-b-popover.html",
                                  value: {
                                    container: "#app",
                                    trigger: "hover",
                                    content: _vm.labelFullName,
                                    placement: "bottom",
                                  },
                                  expression:
                                    "{\n              container: '#app',\n              trigger: 'hover',\n              content: labelFullName,\n              placement: 'bottom',\n            }",
                                  modifiers: { html: true },
                                },
                              ],
                              attrs: { size: "iconic", icon: "info" },
                            }),
                          ],
                          1
                        )
                      : _vm._e(),
                  ]
                )
              : _vm._e(),
            _vm.type === "date" && _vm.editable
              ? _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.textValue,
                      expression: "textValue",
                    },
                    {
                      name: "mask",
                      rawName: "v-mask",
                      value: "##.##.####",
                      expression: "'##.##.####'",
                    },
                  ],
                  ref: "inputdateeditable",
                  staticClass: "c-input-input c-input-input_date",
                  class: {
                    "c-input-input_placeholder_italic":
                      _vm.placeholderStyle === "italic",
                    "c-input-input_size_small": _vm.size === "small",
                  },
                  attrs: { placeholder: "00.00.0000" },
                  domProps: { value: _vm.textValue },
                  on: {
                    focus: function ($event) {
                      _vm.focused = true
                    },
                    input: function ($event) {
                      if ($event.target.composing) return
                      _vm.textValue = $event.target.value
                    },
                  },
                })
              : _vm._e(),
            !_vm.checkbox || _vm.type === "date" || _vm.type === undefined
              ? _c(
                  "div",
                  {
                    staticClass: "c-input-actions",
                    class: {
                      "c-input-actions_size_small": _vm.size === "small",
                    },
                  },
                  [
                    _vm.clearable
                      ? _c(
                          "div",
                          {
                            staticClass: "c-input-action c-input-action_clear",
                            class: {
                              "c-input-action_clear_active":
                                (_vm.multiple
                                  ? !!_vm.selectValue.length
                                  : !!_vm.selectValue) ||
                                _vm.dateValue ||
                                _vm.textValue,
                            },
                          },
                          [
                            _c(
                              "svg",
                              {
                                attrs: {
                                  width: "12",
                                  height: "12",
                                  viewBox: "0 0 12 12",
                                  xmlns: "http://www.w3.org/2000/svg",
                                },
                                on: { click: _vm.clear },
                              },
                              [
                                _c("path", {
                                  attrs: {
                                    d: "M0.325608 10.746C-0.0649162 10.3555 -0.0649162 9.72233 0.325608 9.33181L9.36312 0.292893C9.75364 -0.0976313 10.3868 -0.0976309 10.7773 0.292893C11.1679 0.683418 11.1679 1.31658 10.7773 1.70711L1.73982 10.746C1.3493 11.1365 0.716132 11.1365 0.325608 10.746Z",
                                  },
                                }),
                                _c("path", {
                                  attrs: {
                                    d: "M10.6836 10.6835C11.0741 10.293 11.0741 9.65986 10.6836 9.26933L1.70711 0.292893C1.31658 -0.0976313 0.683417 -0.0976309 0.292893 0.292893C-0.0976311 0.683418 -0.0976311 1.31658 0.292893 1.70711L9.26935 10.6835C9.65987 11.0741 10.293 11.0741 10.6836 10.6835Z",
                                  },
                                }),
                              ]
                            ),
                          ]
                        )
                      : _vm._e(),
                    _vm.type === "text" && _vm.copiedToClipboard
                      ? _c(
                          "div",
                          {
                            staticClass:
                              "c-input-action c-input-action_copy_to_clipboard",
                            class: {
                              "c-input-action_arrow_active": _vm.container,
                            },
                          },
                          [
                            _c("c-button", {
                              directives: [
                                {
                                  name: "b-popover",
                                  rawName: "v-b-popover.html",
                                  value: {
                                    container: "#app",
                                    trigger: "hover blur",
                                    content: "Скопировать в буфер",
                                    placement: "top",
                                  },
                                  expression:
                                    "{\n              container: '#app',\n              trigger: 'hover blur',\n              content: 'Скопировать в буфер',\n              placement: 'top',\n            }",
                                  modifiers: { html: true },
                                },
                              ],
                              attrs: {
                                icon: "copy-to-clipboard",
                                disabled: !_vm.textValue,
                                size: "iconic",
                              },
                              on: { click: _vm.copyToClipboard },
                            }),
                            _vm.copiedToClipboard
                              ? _c("input", {
                                  attrs: {
                                    id: "copy-to-clipboard-hidden-input",
                                    type: "hidden",
                                  },
                                  domProps: { value: _vm.textValue },
                                })
                              : _vm._e(),
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm.type === "select"
                      ? _c(
                          "div",
                          {
                            staticClass: "c-input-action c-input-action_arrow",
                            class: {
                              "c-input-action_arrow_active": _vm.container,
                            },
                          },
                          [
                            _c(
                              "svg",
                              {
                                staticClass: "c-input-action-arrow",
                                attrs: {
                                  width: "12",
                                  height: "7",
                                  viewBox: "0 0 12 7",
                                  xmlns: "http://www.w3.org/2000/svg",
                                },
                                on: { click: _vm.openContainer },
                              },
                              [
                                _c("path", {
                                  attrs: {
                                    d: "M5.30964 6.70905C4.92189 6.32111 4.92189 5.69215 5.30964 5.30421L10.305 0.306472C10.6928 -0.0814626 11.3214 -0.081462 11.7092 0.306473C12.0969 0.694408 12.0969 1.32337 11.7092 1.71131L6.71381 6.70905C6.32606 7.09698 5.69739 7.09698 5.30964 6.70905Z",
                                  },
                                }),
                                _c("path", {
                                  attrs: {
                                    d: "M6.70587 6.70905C7.09363 6.32111 7.09363 5.69215 6.70587 5.30421L1.69498 0.290951C1.30723 -0.096984 0.678565 -0.0969834 0.290814 0.290951C-0.0969378 0.678886 -0.0969378 1.30785 0.290814 1.69579L5.3017 6.70905C5.68946 7.09698 6.31812 7.09698 6.70587 6.70905Z",
                                  },
                                }),
                              ]
                            ),
                          ]
                        )
                      : _vm._e(),
                  ]
                )
              : _vm._e(),
            _vm.checkbox
              ? _c(
                  "div",
                  {
                    staticClass: "c-input-checkbox",
                    class: {
                      "c-input-checkbox-type-icon": _vm.checkboxType === "icon",
                    },
                  },
                  [
                    !_vm.checkboxType
                      ? _c("c-switcher", {
                          attrs: {
                            label: {
                              text: _vm.checkbox.text
                                ? _vm.checkbox.text
                                : _vm.checkbox,
                              color: _vm.checkbox.labelColor
                                ? _vm.checkbox.labelColor
                                : null,
                            },
                            disabled: _vm.value.length === -1,
                            type: "checkbox",
                            nowrap: true,
                          },
                          model: {
                            value: _vm.checkboxValueLocal,
                            callback: function ($$v) {
                              _vm.checkboxValueLocal = $$v
                            },
                            expression: "checkboxValueLocal",
                          },
                        })
                      : _vm._e(),
                    _vm.checkboxType === "icon"
                      ? _c("c-switcher", {
                          attrs: {
                            type: "checkbox-icon",
                            disabled: _vm.value.length === -1,
                            tooltip: _vm.checkboxTooltip,
                          },
                          model: {
                            value: _vm.checkboxValueLocal,
                            callback: function ($$v) {
                              _vm.checkboxValueLocal = $$v
                            },
                            expression: "checkboxValueLocal",
                          },
                        })
                      : _vm._e(),
                  ],
                  1
                )
              : _vm._e(),
            _c("div", {
              staticClass: "c-input-border",
              class: {
                "c-input-border_active": _vm.focused || _vm.container,
                "c-input-border-pink":
                  _vm.invalid ||
                  _vm.inputTextCondition ||
                  _vm.requiredMessage ||
                  _vm.computedErrors.length > 0 ||
                  (_vm.requiredCondition && _vm.required) ||
                  (_vm.required && _vm.type === "date"),
              },
            }),
          ]),
          _vm.actuallyNormalErrorMessages
            ? _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.computedErrors.length > 0,
                      expression: "computedErrors.length > 0",
                    },
                  ],
                  staticClass: "error-messages",
                },
                [
                  _c("div", { staticClass: "error-messages__icon" }, [
                    _c(
                      "svg",
                      {
                        attrs: {
                          width: "14",
                          height: "14",
                          viewBox: "0 0 14 14",
                          fill: "none",
                          xmlns: "http://www.w3.org/2000/svg",
                        },
                      },
                      [
                        _c("circle", {
                          attrs: {
                            cx: "7",
                            cy: "7",
                            r: "6.5",
                            fill: "white",
                            stroke: "#FF238D",
                          },
                        }),
                        _c("circle", {
                          attrs: { cx: "7", cy: "10", r: "1", fill: "#FF238D" },
                        }),
                        _c("rect", {
                          attrs: {
                            x: "6",
                            y: "3",
                            width: "2",
                            height: "5",
                            rx: "1",
                            fill: "#FF238D",
                          },
                        }),
                      ]
                    ),
                  ]),
                  _c(
                    "div",
                    { staticClass: "error-messages__list" },
                    _vm._l(
                      _vm.computedErrors,
                      function (message, messageIndex) {
                        return _c(
                          "div",
                          {
                            key: `err_${messageIndex}`,
                            staticClass: "error-messages__item",
                          },
                          [_vm._v(" " + _vm._s(message) + " ")]
                        )
                      }
                    ),
                    0
                  ),
                ]
              )
            : _vm.computedErrors.length > 0
            ? _c(
                "div",
                { staticClass: "c-input-required 5 c-input-required_active" },
                [
                  _c(
                    "svg",
                    {
                      attrs: {
                        width: "14",
                        height: "14",
                        viewBox: "0 0 14 14",
                        fill: "none",
                        xmlns: "http://www.w3.org/2000/svg",
                      },
                    },
                    [
                      _c("circle", {
                        attrs: {
                          cx: "7",
                          cy: "7",
                          r: "6.5",
                          fill: "white",
                          stroke: "#FF238D",
                        },
                      }),
                      _c("circle", {
                        attrs: { cx: "7", cy: "10", r: "1", fill: "#FF238D" },
                      }),
                      _c("rect", {
                        attrs: {
                          x: "6",
                          y: "3",
                          width: "2",
                          height: "5",
                          rx: "1",
                          fill: "#FF238D",
                        },
                      }),
                    ]
                  ),
                  _c("div", { staticClass: "c-input-required-text" }, [
                    _vm._v(_vm._s(_vm.computedErrors.join("; "))),
                  ]),
                ]
              )
            : _vm._e(),
          _vm.required
            ? _c(
                "div",
                {
                  staticClass: "c-input-required 1",
                  class: {
                    "c-input-required_active":
                      !_vm.type ||
                      [
                        "date",
                        "password",
                        "period",
                        "period-without-fixed-intervals",
                        "text",
                        "number",
                      ].includes(_vm.type),
                  },
                },
                [
                  _c(
                    "svg",
                    {
                      attrs: {
                        width: "14",
                        height: "14",
                        viewBox: "0 0 14 14",
                        fill: "none",
                        xmlns: "http://www.w3.org/2000/svg",
                      },
                    },
                    [
                      _c("circle", {
                        attrs: {
                          cx: "7",
                          cy: "7",
                          r: "6.5",
                          fill: "white",
                          stroke: "#FF238D",
                        },
                      }),
                      _c("circle", {
                        attrs: { cx: "7", cy: "10", r: "1", fill: "#FF238D" },
                      }),
                      _c("rect", {
                        attrs: {
                          x: "6",
                          y: "3",
                          width: "2",
                          height: "5",
                          rx: "1",
                          fill: "#FF238D",
                        },
                      }),
                    ]
                  ),
                  _c("div", { staticClass: "c-input-required-text" }, [
                    _vm._v(_vm._s(_vm.required)),
                  ]),
                ]
              )
            : _vm._e(),
          _vm.inputTextCondition
            ? _c(
                "div",
                {
                  staticClass: "c-input-required c-input-required_active 2",
                  class: { "c-input-required_active": _vm.value.length < 3 },
                },
                [
                  _c(
                    "svg",
                    {
                      attrs: {
                        width: "14",
                        height: "14",
                        viewBox: "0 0 14 14",
                        fill: "none",
                        xmlns: "http://www.w3.org/2000/svg",
                      },
                    },
                    [
                      _c("circle", {
                        attrs: {
                          cx: "7",
                          cy: "7",
                          r: "6.5",
                          fill: "white",
                          stroke: "#FF238D",
                        },
                      }),
                      _c("circle", {
                        attrs: { cx: "7", cy: "10", r: "1", fill: "#FF238D" },
                      }),
                      _c("rect", {
                        attrs: {
                          x: "6",
                          y: "3",
                          width: "2",
                          height: "5",
                          rx: "1",
                          fill: "#FF238D",
                        },
                      }),
                    ]
                  ),
                  _c("div", { staticClass: "c-input-required-text" }, [
                    _vm._v(_vm._s(_vm.inputTextCondition)),
                  ]),
                ]
              )
            : _vm._e(),
          _vm.required && _vm.requiredCondition
            ? _c(
                "div",
                {
                  staticClass: "c-input-required 3",
                  class: {
                    "c-input-required_active":
                      _vm.type === "select" ||
                      _vm.type === "integer-number" ||
                      _vm.type === "price-number",
                  },
                },
                [
                  _c(
                    "svg",
                    {
                      attrs: {
                        width: "14",
                        height: "14",
                        viewBox: "0 0 14 14",
                        fill: "none",
                        xmlns: "http://www.w3.org/2000/svg",
                      },
                    },
                    [
                      _c("circle", {
                        attrs: {
                          cx: "7",
                          cy: "7",
                          r: "6.5",
                          fill: "white",
                          stroke: "#FF238D",
                        },
                      }),
                      _c("circle", {
                        attrs: { cx: "7", cy: "10", r: "1", fill: "#FF238D" },
                      }),
                      _c("rect", {
                        attrs: {
                          x: "6",
                          y: "3",
                          width: "2",
                          height: "5",
                          rx: "1",
                          fill: "#FF238D",
                        },
                      }),
                    ]
                  ),
                  _c("div", { staticClass: "c-input-required-text" }, [
                    _vm._v(_vm._s(_vm.required)),
                  ]),
                ]
              )
            : _vm._e(),
          _vm.type === "select" ||
          _vm.type === "date" ||
          _vm.type === "period" ||
          _vm.type === "period-without-fixed-intervals"
            ? _c(
                "div",
                {
                  ref: "inputContainer",
                  staticClass: "c-input-container",
                  class: {
                    "c-input-container_active": _vm.containerActive,
                    "c-input-container_date": _vm.type === "date",
                    "c-input-container_period": _vm.type === "period",
                    "c-input-container_period-without-fixed-intervals":
                      _vm.type === "period-without-fixed-intervals",
                    "c-input-container_size_small": _vm.size === "small",
                    "c-input-container_nolabel":
                      !_vm.label && !_vm.floatingLabel,
                    "c-input-container_right":
                      this.correctPositionContainer &&
                      this.correctPositionContainer === "right",
                    "c-input-container_left":
                      this.correctPositionContainer &&
                      this.correctPositionContainer === "left",
                  },
                },
                [
                  _vm.type === "period" ||
                  _vm.type === "period-without-fixed-intervals" ||
                  _vm.type === "date"
                    ? _c(
                        "div",
                        {
                          staticClass: "c-input-container-close",
                          on: { click: _vm.closeContainer },
                        },
                        [
                          _c(
                            "svg",
                            {
                              attrs: {
                                width: "15",
                                height: "16",
                                viewBox: "0 0 15 16",
                                fill: "none",
                                xmlns: "http://www.w3.org/2000/svg",
                              },
                            },
                            [
                              _c("path", {
                                attrs: {
                                  d: "M10.6045 11.5377C10.2154 11.9267 9.58272 11.9247 9.19126 11.5333L3.53712 5.88051C3.14565 5.48904 3.14367 4.85633 3.5327 4.4673C3.92172 4.07828 4.55443 4.08026 4.9459 4.47173L10.6 10.1245C10.9915 10.5159 10.9935 11.1486 10.6045 11.5377Z",
                                  fill: "#8E9CBB",
                                },
                              }),
                              _c("path", {
                                attrs: {
                                  d: "M10.6127 4.47053C10.2212 4.07907 9.58849 4.07709 9.19947 4.46611L3.53718 10.1284C3.14816 10.5174 3.15014 11.1501 3.54161 11.5416C3.93307 11.9331 4.56579 11.9351 4.95481 11.546L10.6171 5.88374C11.0061 5.49471 11.0041 4.862 10.6127 4.47053Z",
                                  fill: "#8E9CBB",
                                },
                              }),
                            ]
                          ),
                        ]
                      )
                    : _vm._e(),
                  _vm.searchable
                    ? _c(
                        "div",
                        {
                          staticClass: "c-input-container-search",
                          class: {
                            "c-input-container-search-with-special-value":
                              _vm.withSpecialValue,
                          },
                        },
                        [
                          _c(
                            "div",
                            { staticClass: "c-input-container-search-icon" },
                            [
                              _c(
                                "svg",
                                {
                                  attrs: {
                                    width: "13",
                                    height: "13",
                                    viewBox: "0 0 17 17",
                                    xmlns: "http://www.w3.org/2000/svg",
                                  },
                                },
                                [
                                  _c("path", {
                                    attrs: {
                                      d: "M11.4142 11L15.6569 15.2426M13 7C13 10.3137 10.3137 13 7 13C3.68629 13 1 10.3137 1 7C1 3.68629 3.68629 1 7 1C10.3137 1 13 3.68629 13 7Z",
                                      "stroke-width": "2",
                                      "stroke-linecap": "round",
                                    },
                                  }),
                                ]
                              ),
                            ]
                          ),
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.selectSearch,
                                expression: "selectSearch",
                              },
                            ],
                            staticClass: "c-input-container-search-input",
                            attrs: { type: "text", placeholder: "Поиск" },
                            domProps: { value: _vm.selectSearch },
                            on: {
                              input: function ($event) {
                                if ($event.target.composing) return
                                _vm.selectSearch = $event.target.value
                              },
                            },
                          }),
                          _vm.selectSearch.length > 0
                            ? _c(
                                "div",
                                {
                                  staticClass:
                                    "c-input-container-search-icon-clear",
                                  on: {
                                    click: function ($event) {
                                      _vm.selectSearch = ""
                                    },
                                  },
                                },
                                [
                                  _c(
                                    "svg",
                                    {
                                      attrs: {
                                        width: "12",
                                        height: "12",
                                        viewBox: "0 0 12 12",
                                        fill: "none",
                                        xmlns: "http://www.w3.org/2000/svg",
                                      },
                                    },
                                    [
                                      _c("path", {
                                        attrs: {
                                          d: "M0.325608 10.746C-0.0649162 10.3555 -0.0649162 9.72233 0.325608 9.33181L9.36312 0.292893C9.75364 -0.0976313 10.3868 -0.0976309 10.7773 0.292893C11.1679 0.683418 11.1679 1.31658 10.7773 1.70711L1.73982 10.746C1.3493 11.1365 0.716132 11.1365 0.325608 10.746Z",
                                          fill: "#FF238D",
                                        },
                                      }),
                                      _c("path", {
                                        attrs: {
                                          d: "M10.6836 10.6835C11.0741 10.293 11.0741 9.65986 10.6836 9.26933L1.70711 0.292893C1.31658 -0.0976313 0.683417 -0.0976309 0.292893 0.292893C-0.0976311 0.683418 -0.0976311 1.31658 0.292893 1.70711L9.26935 10.6835C9.65987 11.0741 10.293 11.0741 10.6836 10.6835Z",
                                          fill: "#FF238D",
                                        },
                                      }),
                                    ]
                                  ),
                                ]
                              )
                            : _vm._e(),
                          _c("div", {
                            staticClass: "c-input-container-search-border",
                          }),
                        ]
                      )
                    : _vm._e(),
                  _vm.type === "select"
                    ? _c(
                        "div",
                        {
                          staticClass: "c-input-container-list",
                          class: {
                            "c-input-container-list-active": !_vm.multiple,
                          },
                        },
                        [
                          _vm.selectSearchEmpty
                            ? _c(
                                "div",
                                {
                                  staticClass:
                                    "c-input-container-list-item c-input-container-list-item_empty",
                                  class: {
                                    "c-input-container-list-item_empty_size_small":
                                      _vm.size === "small",
                                  },
                                },
                                [_vm._v(" Совпадений не найдено ")]
                              )
                            : !_vm.selectItems || !_vm.selectItems.length
                            ? _c(
                                "div",
                                {
                                  staticClass:
                                    "c-input-container-list-item c-input-container-list-item_empty",
                                  class: {
                                    "c-input-container-list-item_empty_size_small":
                                      _vm.size === "small",
                                  },
                                },
                                [_vm._v(" Справочник значений пустой ")]
                              )
                            : _vm._e(),
                          _vm._l(_vm.selectItems, function (item) {
                            return _c(
                              "div",
                              {
                                key: item.value,
                                staticClass: "c-input-container-list-item",
                                class: {
                                  "c-input-container-list-item_disabled":
                                    _vm.isItemDisabled(item),
                                  "c-input-container-list-item_with_avatar":
                                    item.avatar && _vm.itemsWithAvatar,
                                  "c-input-container-list-item_selected":
                                    item === _vm.selectValue,
                                  "c-input-container-list-item_special":
                                    item.specialValue !== undefined &&
                                    item.specialValue,
                                  "c-input-container-list-item_category":
                                    _vm.withCategorized && !item.isSubCategory,
                                  "c-input-container-list-item_subcategory":
                                    _vm.withCategorized && item.isSubCategory,
                                },
                                style: {
                                  "margin-left": item.level * 10 + "px",
                                },
                                on: { click: (e) => _vm.selectItem(e, item) },
                              },
                              [
                                item.avatar && _vm.itemsWithAvatar
                                  ? _c("div", {
                                      staticClass:
                                        "c-input-container-list-item-avatar",
                                      style: {
                                        backgroundImage: `url(${item.avatar})`,
                                      },
                                    })
                                  : _vm._e(),
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "c-input-container-list-item-label",
                                    class: {
                                      "c-input-container-list-item-label-bold":
                                        item.specialValue !== undefined &&
                                        item.specialValue,
                                    },
                                  },
                                  [
                                    _c("span", {
                                      domProps: {
                                        innerHTML: _vm._s(
                                          item.formatLabel || item.label
                                        ),
                                      },
                                    }),
                                    item.subLabel
                                      ? _c(
                                          "div",
                                          {
                                            staticClass: "list-item-sublabel 2",
                                          },
                                          [
                                            _vm._v(
                                              " " + _vm._s(item.subLabel) + " "
                                            ),
                                          ]
                                        )
                                      : _vm._e(),
                                  ]
                                ),
                                item.specialValue !== undefined &&
                                item.specialValue
                                  ? _c("div", {
                                      staticClass:
                                        "c-input-container-list-item-border",
                                    })
                                  : _vm._e(),
                              ]
                            )
                          }),
                        ],
                        2
                      )
                    : _vm._e(),
                  _vm.type === "select" && _vm.multiple
                    ? _c(
                        "div",
                        {
                          staticClass:
                            "c-input-container-list c-input-container-list-mobile",
                        },
                        [
                          _vm.selectSearchEmpty
                            ? _c(
                                "div",
                                {
                                  staticClass:
                                    "c-input-container-list-item c-input-container-list-item_empty",
                                  class: {
                                    "c-input-container-list-item_empty_size_small":
                                      _vm.size === "small",
                                  },
                                },
                                [_vm._v(" Совпадений не найдено ")]
                              )
                            : !_vm.selectItems || !_vm.selectItems.length
                            ? _c(
                                "div",
                                {
                                  staticClass:
                                    "c-input-container-list-item c-input-container-list-item_empty",
                                  class: {
                                    "c-input-container-list-item_empty_size_small":
                                      _vm.size === "small",
                                  },
                                },
                                [_vm._v(" Справочник значений пустой ")]
                              )
                            : _vm._e(),
                          _vm._l(_vm.selectItems, function (item) {
                            return _c(
                              "div",
                              {
                                key: item.value,
                                staticClass: "c-input-container-list-item",
                                class: {
                                  "c-input-container-list-item_with_avatar":
                                    item.avatar && _vm.itemsWithAvatar,
                                },
                              },
                              [
                                _c("c-switcher", {
                                  attrs: {
                                    id: item.value,
                                    label: {
                                      text: item.label,
                                      color: null,
                                    },
                                    type: "checkbox",
                                    value: item,
                                    checked: item,
                                    multi: true,
                                    nowrap: true,
                                  },
                                  model: {
                                    value: _vm.checkedMobileMultipleSelects,
                                    callback: function ($$v) {
                                      _vm.checkedMobileMultipleSelects = $$v
                                    },
                                    expression: "checkedMobileMultipleSelects",
                                  },
                                }),
                              ],
                              1
                            )
                          }),
                        ],
                        2
                      )
                    : _vm._e(),
                  _vm.type === "select"
                    ? _c(
                        "div",
                        {
                          staticClass: "c-input-container-list-mobile-buttons",
                        },
                        [
                          _c("c-button", {
                            staticClass:
                              "c-input-container-list-mobile-buttons-cancel",
                            attrs: { size: "small", label: "Отмена" },
                            on: { click: _vm.closeContainer },
                          }),
                          _vm.multiple
                            ? _c("c-button", {
                                attrs: {
                                  size: "small",
                                  label: "Готово",
                                  color: "primary",
                                },
                                on: { click: _vm.selectItemsMobileMultiple },
                              })
                            : _vm._e(),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.type === "date"
                    ? _c(
                        "div",
                        {
                          staticClass: "c-input-container-date",
                          class: {
                            "with-selects": _vm.selects,
                          },
                        },
                        [
                          _vm.selects
                            ? _c(
                                "div",
                                { staticClass: "selects" },
                                [
                                  _c("c-select", {
                                    staticClass: "year",
                                    attrs: {
                                      items: _vm.years,
                                      "scroll-to-selected": true,
                                    },
                                    model: {
                                      value: _vm.year,
                                      callback: function ($$v) {
                                        _vm.year = $$v
                                      },
                                      expression: "year",
                                    },
                                  }),
                                  _c("c-select", {
                                    staticClass: "month",
                                    attrs: { items: _vm.months },
                                    model: {
                                      value: _vm.month,
                                      callback: function ($$v) {
                                        _vm.month = $$v
                                      },
                                      expression: "month",
                                    },
                                  }),
                                ],
                                1
                              )
                            : _vm._e(),
                          _c("datepicker", {
                            ref: "inputTypeDateDatepicker",
                            attrs: {
                              "open-date": _vm.selects ? _vm.openDate : null,
                              inline: true,
                              language: _vm.ru,
                              "full-month-name": true,
                              "monday-first": true,
                              "calendar-class": "c-input-container-calendar",
                            },
                            on: {
                              selected: _vm.closeContainerDatepickerContainer,
                            },
                            model: {
                              value: _vm.selectedDate,
                              callback: function ($$v) {
                                _vm.selectedDate = $$v
                              },
                              expression: "selectedDate",
                            },
                          }),
                          _c(
                            "div",
                            {
                              staticClass:
                                "c-input-container-date-actions-mobile",
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "c-input-container-date-actions-mobile-item",
                                  on: { click: _vm.dateReset },
                                },
                                [_vm._v("Сбросить")]
                              ),
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "c-input-container-date-actions-mobile-item",
                                  on: { click: _vm.dateSubmit },
                                },
                                [_vm._v("Применить")]
                              ),
                            ]
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.type === "period"
                    ? _c("div", { staticClass: "c-input-container-period" }, [
                        _c(
                          "div",
                          {
                            staticClass:
                              "c-input-container-period-actions-mobile",
                          },
                          [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "c-input-container-period-actions-mobile-item",
                                on: { click: _vm.periodReset },
                              },
                              [_vm._v("Сбросить")]
                            ),
                            _c(
                              "div",
                              {
                                staticClass:
                                  "c-input-container-period-actions-mobile-item",
                                on: { click: _vm.periodSubmit },
                              },
                              [_vm._v("Применить")]
                            ),
                          ]
                        ),
                        _c(
                          "div",
                          {
                            staticClass: "c-input-container-period-calendars",
                            class: {
                              "c-input-container-period-calendars_disabled": false,
                            },
                          },
                          [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "c-input-container-period-calendars-item",
                                class: {
                                  "c-input-container-period-calendars-item_active":
                                    _vm.period.activeCalendar === "start" &&
                                    _vm.container !== false,
                                },
                              },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "c-input-container-period-input-wrapper",
                                    class: {
                                      "c-input-container-period-input-wrapper-required":
                                        _vm.isNotValidPeriodDateStart(),
                                    },
                                  },
                                  [
                                    _c("the-mask", {
                                      staticClass:
                                        "c-input-container-period-input",
                                      attrs: {
                                        mask: "##.##.####",
                                        type: "text",
                                        placeholder: "00.00.0000",
                                        masked: true,
                                      },
                                      model: {
                                        value: _vm.period.start.input,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.period.start,
                                            "input",
                                            $$v
                                          )
                                        },
                                        expression: "period.start.input",
                                      },
                                    }),
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "c-input-container-period-input-icon",
                                      },
                                      [
                                        _c(
                                          "svg",
                                          {
                                            attrs: {
                                              width: "18",
                                              height: "18",
                                              viewBox: "0 0 18 18",
                                              fill: "none",
                                              xmlns:
                                                "http://www.w3.org/2000/svg",
                                            },
                                          },
                                          [
                                            _c("path", {
                                              attrs: {
                                                d: "M15.2222 3H2.77778C1.79594 3 1 3.69645 1 4.55556V15.4444C1 16.3036 1.79594 17 2.77778 17H15.2222C16.2041 17 17 16.3036 17 15.4444V4.55556C17 3.69645 16.2041 3 15.2222 3Z",
                                                stroke: "#8E9CBB",
                                                "stroke-width": "2",
                                                "stroke-linecap": "round",
                                                "stroke-linejoin": "round",
                                              },
                                            }),
                                            _c("path", {
                                              attrs: {
                                                d: "M13 1V5",
                                                stroke: "#8E9CBB",
                                                "stroke-width": "2",
                                                "stroke-linecap": "round",
                                                "stroke-linejoin": "round",
                                              },
                                            }),
                                            _c("path", {
                                              attrs: {
                                                d: "M5 1V5",
                                                stroke: "#8E9CBB",
                                                "stroke-width": "2",
                                                "stroke-linecap": "round",
                                                "stroke-linejoin": "round",
                                              },
                                            }),
                                            _c("rect", {
                                              attrs: {
                                                x: "4",
                                                y: "8",
                                                width: "2",
                                                height: "2",
                                                fill: "#8E9CBB",
                                              },
                                            }),
                                            _c("rect", {
                                              attrs: {
                                                x: "4",
                                                y: "12",
                                                width: "2",
                                                height: "2",
                                                fill: "#8E9CBB",
                                              },
                                            }),
                                            _c("rect", {
                                              attrs: {
                                                x: "8",
                                                y: "8",
                                                width: "2",
                                                height: "2",
                                                fill: "#8E9CBB",
                                              },
                                            }),
                                            _c("rect", {
                                              attrs: {
                                                x: "8",
                                                y: "12",
                                                width: "2",
                                                height: "2",
                                                fill: "#8E9CBB",
                                              },
                                            }),
                                            _c("rect", {
                                              attrs: {
                                                x: "12",
                                                y: "8",
                                                width: "2",
                                                height: "2",
                                                fill: "#8E9CBB",
                                              },
                                            }),
                                            _c("rect", {
                                              attrs: {
                                                x: "12",
                                                y: "12",
                                                width: "2",
                                                height: "2",
                                                fill: "#8E9CBB",
                                              },
                                            }),
                                          ]
                                        ),
                                      ]
                                    ),
                                  ],
                                  1
                                ),
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "c-input-container-period-calendar",
                                  },
                                  [
                                    _c("datepicker", {
                                      attrs: {
                                        inline: true,
                                        language: _vm.ru,
                                        "full-month-name": true,
                                        "monday-first": true,
                                        highlighted: {
                                          from: _vm.period.start.highlighted,
                                          to: _vm.period.end.highlighted,
                                        },
                                        "open-date": _vm.period.startMonth,
                                        "calendar-class":
                                          "c-input-container-calendar c-input-container-calendar_period",
                                      },
                                      on: {
                                        changedMonth: _vm.changedStartMonth,
                                        selected: _vm.periodSelectDay,
                                      },
                                      model: {
                                        value: _vm.period.start.selected,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.period.start,
                                            "selected",
                                            $$v
                                          )
                                        },
                                        expression: "period.start.selected",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ]
                            ),
                            _c(
                              "div",
                              {
                                staticClass:
                                  "c-input-container-period-calendars-item",
                                class: {
                                  "c-input-container-period-calendars-item_active":
                                    _vm.period.activeCalendar === "end" &&
                                    _vm.container !== false,
                                },
                              },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "c-input-container-period-input-wrapper",
                                    class: {
                                      "c-input-container-period-input-wrapper-required":
                                        _vm.isNotValidPeriodDateEnd(),
                                    },
                                  },
                                  [
                                    _c("the-mask", {
                                      staticClass:
                                        "c-input-container-period-input",
                                      attrs: {
                                        mask: "##.##.####",
                                        type: "text",
                                        placeholder: "00.00.0000",
                                        masked: true,
                                      },
                                      model: {
                                        value: _vm.period.end.input,
                                        callback: function ($$v) {
                                          _vm.$set(_vm.period.end, "input", $$v)
                                        },
                                        expression: "period.end.input",
                                      },
                                    }),
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "c-input-container-period-input-icon",
                                      },
                                      [
                                        _c(
                                          "svg",
                                          {
                                            attrs: {
                                              width: "18",
                                              height: "18",
                                              viewBox: "0 0 18 18",
                                              fill: "none",
                                              xmlns:
                                                "http://www.w3.org/2000/svg",
                                            },
                                          },
                                          [
                                            _c("path", {
                                              attrs: {
                                                d: "M15.2222 3H2.77778C1.79594 3 1 3.69645 1 4.55556V15.4444C1 16.3036 1.79594 17 2.77778 17H15.2222C16.2041 17 17 16.3036 17 15.4444V4.55556C17 3.69645 16.2041 3 15.2222 3Z",
                                                stroke: "#8E9CBB",
                                                "stroke-width": "2",
                                                "stroke-linecap": "round",
                                                "stroke-linejoin": "round",
                                              },
                                            }),
                                            _c("path", {
                                              attrs: {
                                                d: "M13 1V5",
                                                stroke: "#8E9CBB",
                                                "stroke-width": "2",
                                                "stroke-linecap": "round",
                                                "stroke-linejoin": "round",
                                              },
                                            }),
                                            _c("path", {
                                              attrs: {
                                                d: "M5 1V5",
                                                stroke: "#8E9CBB",
                                                "stroke-width": "2",
                                                "stroke-linecap": "round",
                                                "stroke-linejoin": "round",
                                              },
                                            }),
                                            _c("rect", {
                                              attrs: {
                                                x: "4",
                                                y: "8",
                                                width: "2",
                                                height: "2",
                                                fill: "#8E9CBB",
                                              },
                                            }),
                                            _c("rect", {
                                              attrs: {
                                                x: "4",
                                                y: "12",
                                                width: "2",
                                                height: "2",
                                                fill: "#8E9CBB",
                                              },
                                            }),
                                            _c("rect", {
                                              attrs: {
                                                x: "8",
                                                y: "8",
                                                width: "2",
                                                height: "2",
                                                fill: "#8E9CBB",
                                              },
                                            }),
                                            _c("rect", {
                                              attrs: {
                                                x: "8",
                                                y: "12",
                                                width: "2",
                                                height: "2",
                                                fill: "#8E9CBB",
                                              },
                                            }),
                                            _c("rect", {
                                              attrs: {
                                                x: "12",
                                                y: "8",
                                                width: "2",
                                                height: "2",
                                                fill: "#8E9CBB",
                                              },
                                            }),
                                            _c("rect", {
                                              attrs: {
                                                x: "12",
                                                y: "12",
                                                width: "2",
                                                height: "2",
                                                fill: "#8E9CBB",
                                              },
                                            }),
                                          ]
                                        ),
                                      ]
                                    ),
                                  ],
                                  1
                                ),
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "c-input-container-period-calendar",
                                  },
                                  [
                                    _c("datepicker", {
                                      attrs: {
                                        inline: true,
                                        language: _vm.ru,
                                        "full-month-name": true,
                                        "monday-first": true,
                                        highlighted: {
                                          from: _vm.period.start.highlighted,
                                          to: _vm.period.end.highlighted,
                                        },
                                        "open-date": _vm.period.endMonth,
                                        "calendar-class":
                                          "c-input-container-calendar c-input-container-calendar_period",
                                      },
                                      on: {
                                        changedMonth: _vm.changedEndMonth,
                                        selected: _vm.periodSelectDay,
                                      },
                                      model: {
                                        value: _vm.period.end.selected,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.period.end,
                                            "selected",
                                            $$v
                                          )
                                        },
                                        expression: "period.end.selected",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ]
                            ),
                          ]
                        ),
                        _c(
                          "div",
                          { staticClass: "c-input-container-period-switcher" },
                          [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "c-input-container-period-switcher-item",
                                class: {
                                  "c-input-container-period-switcher-item_active":
                                    _vm.period.activeCalendar === "start",
                                },
                                on: {
                                  click: function ($event) {
                                    _vm.period.activeCalendar = "start"
                                  },
                                },
                              },
                              [_c("span", [_vm._v("Начало периода")])]
                            ),
                            _c(
                              "div",
                              {
                                staticClass:
                                  "c-input-container-period-switcher-item",
                                class: {
                                  "c-input-container-period-switcher-item_active":
                                    _vm.period.activeCalendar === "end",
                                },
                                on: {
                                  click: function ($event) {
                                    _vm.period.activeCalendar = "end"
                                  },
                                },
                              },
                              [_c("span", [_vm._v("Конец периода")])]
                            ),
                          ]
                        ),
                        _c(
                          "div",
                          { staticClass: "c-input-container-period-right" },
                          [
                            _c(
                              "div",
                              { staticClass: "c-input-container-period-links" },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "c-input-container-period-link",
                                    class: {
                                      "c-input-container-period-link_active":
                                        _vm.period.range === "yesterday",
                                    },
                                    on: {
                                      click: function ($event) {
                                        _vm.period.range = "yesterday"
                                      },
                                    },
                                  },
                                  [_vm._v(" Вчера ")]
                                ),
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "c-input-container-period-link",
                                    class: {
                                      "c-input-container-period-link_active":
                                        _vm.period.range === "today",
                                    },
                                    on: {
                                      click: function ($event) {
                                        _vm.period.range = "today"
                                      },
                                    },
                                  },
                                  [_vm._v(" Сегодня ")]
                                ),
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "c-input-container-period-link",
                                    class: {
                                      "c-input-container-period-link_active":
                                        _vm.period.range === "begin-week",
                                    },
                                    on: {
                                      click: function ($event) {
                                        _vm.period.range = "begin-week"
                                      },
                                    },
                                  },
                                  [_vm._v(" C начала недели ")]
                                ),
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "c-input-container-period-link",
                                    class: {
                                      "c-input-container-period-link_active":
                                        _vm.period.range === "past-week",
                                    },
                                    on: {
                                      click: function ($event) {
                                        _vm.period.range = "past-week"
                                      },
                                    },
                                  },
                                  [_vm._v(" Прошлая неделя ")]
                                ),
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "c-input-container-period-link",
                                    class: {
                                      "c-input-container-period-link_active":
                                        _vm.period.range === "last-7-days",
                                    },
                                    on: {
                                      click: function ($event) {
                                        _vm.period.range = "last-7-days"
                                      },
                                    },
                                  },
                                  [_vm._v(" Последние 7 дней ")]
                                ),
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "c-input-container-period-link",
                                    class: {
                                      "c-input-container-period-link_active":
                                        _vm.period.range === "current-month",
                                    },
                                    on: {
                                      click: function ($event) {
                                        _vm.period.range = "current-month"
                                      },
                                    },
                                  },
                                  [_vm._v(" Текущий месяц ")]
                                ),
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "c-input-container-period-link",
                                    class: {
                                      "c-input-container-period-link_active":
                                        _vm.period.range === "past-month",
                                    },
                                    on: {
                                      click: function ($event) {
                                        _vm.period.range = "past-month"
                                      },
                                    },
                                  },
                                  [_vm._v(" Прошлый месяц ")]
                                ),
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "c-input-container-period-link",
                                    class: {
                                      "c-input-container-period-link_active":
                                        _vm.period.range === "last-month",
                                    },
                                    on: {
                                      click: function ($event) {
                                        _vm.period.range = "last-month"
                                      },
                                    },
                                  },
                                  [_vm._v(" Последний месяц ")]
                                ),
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "c-input-container-period-link",
                                    class: {
                                      "c-input-container-period-link_active":
                                        _vm.period.range === "custom",
                                    },
                                    on: {
                                      click: function ($event) {
                                        _vm.period.range = "custom"
                                      },
                                    },
                                  },
                                  [_vm._v(" Произвольный период ")]
                                ),
                              ]
                            ),
                            _c(
                              "div",
                              {
                                staticClass: "c-input-container-period-actions",
                              },
                              [
                                _c("c-button", {
                                  staticClass:
                                    "c-input-container-period-action",
                                  attrs: {
                                    size: "small",
                                    label: "Применить",
                                    icon: { icon: "check", color: "success" },
                                  },
                                  on: { click: _vm.periodSubmit },
                                }),
                                _c("c-button", {
                                  staticClass:
                                    "c-input-container-period-action",
                                  attrs: {
                                    size: "small",
                                    label: "Сбросить",
                                    icon: { icon: "close", color: "secondary" },
                                  },
                                  on: { click: _vm.periodReset },
                                }),
                              ],
                              1
                            ),
                          ]
                        ),
                      ])
                    : _vm._e(),
                  _vm.type === "period-without-fixed-intervals"
                    ? _c(
                        "div",
                        {
                          staticClass:
                            "c-input-container-period c-input-container-period-without-fixed-intervals",
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass:
                                "c-input-container-period-actions-mobile",
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "c-input-container-period-actions-mobile-item",
                                  on: { click: _vm.periodReset },
                                },
                                [_vm._v("Сбросить")]
                              ),
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "c-input-container-period-actions-mobile-item",
                                  on: { click: _vm.periodSubmit },
                                },
                                [_vm._v("Применить")]
                              ),
                            ]
                          ),
                          _c(
                            "div",
                            {
                              staticClass: "c-input-container-period-calendars",
                              class: {
                                "c-input-container-period-calendars_disabled": false,
                              },
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "c-input-container-period-calendars-item",
                                  class: {
                                    "c-input-container-period-calendars-item_active":
                                      _vm.period.activeCalendar === "start" &&
                                      _vm.container !== false,
                                  },
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "c-input-container-period-input-wrapper",
                                      class: {
                                        "c-input-container-period-input-wrapper-required":
                                          _vm.isNotValidPeriodDateStart(),
                                      },
                                    },
                                    [
                                      _c("the-mask", {
                                        staticClass:
                                          "c-input-container-period-input",
                                        attrs: {
                                          mask: "##.##.####",
                                          type: "text",
                                          placeholder: "00.00.0000",
                                          masked: true,
                                        },
                                        model: {
                                          value: _vm.period.start.input,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.period.start,
                                              "input",
                                              $$v
                                            )
                                          },
                                          expression: "period.start.input",
                                        },
                                      }),
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "c-input-container-period-input-icon",
                                        },
                                        [
                                          _c(
                                            "svg",
                                            {
                                              attrs: {
                                                width: "18",
                                                height: "18",
                                                viewBox: "0 0 18 18",
                                                fill: "none",
                                                xmlns:
                                                  "http://www.w3.org/2000/svg",
                                              },
                                            },
                                            [
                                              _c("path", {
                                                attrs: {
                                                  d: "M15.2222 3H2.77778C1.79594 3 1 3.69645 1 4.55556V15.4444C1 16.3036 1.79594 17 2.77778 17H15.2222C16.2041 17 17 16.3036 17 15.4444V4.55556C17 3.69645 16.2041 3 15.2222 3Z",
                                                  stroke: "#8E9CBB",
                                                  "stroke-width": "2",
                                                  "stroke-linecap": "round",
                                                  "stroke-linejoin": "round",
                                                },
                                              }),
                                              _c("path", {
                                                attrs: {
                                                  d: "M13 1V5",
                                                  stroke: "#8E9CBB",
                                                  "stroke-width": "2",
                                                  "stroke-linecap": "round",
                                                  "stroke-linejoin": "round",
                                                },
                                              }),
                                              _c("path", {
                                                attrs: {
                                                  d: "M5 1V5",
                                                  stroke: "#8E9CBB",
                                                  "stroke-width": "2",
                                                  "stroke-linecap": "round",
                                                  "stroke-linejoin": "round",
                                                },
                                              }),
                                              _c("rect", {
                                                attrs: {
                                                  x: "4",
                                                  y: "8",
                                                  width: "2",
                                                  height: "2",
                                                  fill: "#8E9CBB",
                                                },
                                              }),
                                              _c("rect", {
                                                attrs: {
                                                  x: "4",
                                                  y: "12",
                                                  width: "2",
                                                  height: "2",
                                                  fill: "#8E9CBB",
                                                },
                                              }),
                                              _c("rect", {
                                                attrs: {
                                                  x: "8",
                                                  y: "8",
                                                  width: "2",
                                                  height: "2",
                                                  fill: "#8E9CBB",
                                                },
                                              }),
                                              _c("rect", {
                                                attrs: {
                                                  x: "8",
                                                  y: "12",
                                                  width: "2",
                                                  height: "2",
                                                  fill: "#8E9CBB",
                                                },
                                              }),
                                              _c("rect", {
                                                attrs: {
                                                  x: "12",
                                                  y: "8",
                                                  width: "2",
                                                  height: "2",
                                                  fill: "#8E9CBB",
                                                },
                                              }),
                                              _c("rect", {
                                                attrs: {
                                                  x: "12",
                                                  y: "12",
                                                  width: "2",
                                                  height: "2",
                                                  fill: "#8E9CBB",
                                                },
                                              }),
                                            ]
                                          ),
                                        ]
                                      ),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "c-input-container-period-calendar",
                                    },
                                    [
                                      _c("datepicker", {
                                        attrs: {
                                          inline: true,
                                          language: _vm.ru,
                                          "full-month-name": true,
                                          "monday-first": true,
                                          selects: _vm.selects,
                                          highlighted: {
                                            from: _vm.period.start.highlighted,
                                            to: _vm.period.end.highlighted,
                                          },
                                          "open-date": _vm.period.startMonth,
                                          "calendar-class":
                                            "c-input-container-calendar c-input-container-calendar_period c-input-container-calendar_period-without-fixed-intervals",
                                        },
                                        on: {
                                          changedMonth: _vm.changedStartMonth,
                                          selected: _vm.periodSelectDay,
                                        },
                                        model: {
                                          value: _vm.period.start.selected,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.period.start,
                                              "selected",
                                              $$v
                                            )
                                          },
                                          expression: "period.start.selected",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ]
                              ),
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "c-input-container-period-calendars-item",
                                  class: {
                                    "c-input-container-period-calendars-item_active":
                                      _vm.period.activeCalendar === "end" &&
                                      _vm.container !== false,
                                  },
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "c-input-container-period-input-wrapper",
                                      class: {
                                        "c-input-container-period-input-wrapper-required":
                                          _vm.isNotValidPeriodDateEnd(),
                                      },
                                    },
                                    [
                                      _c("the-mask", {
                                        staticClass:
                                          "c-input-container-period-input",
                                        attrs: {
                                          mask: "##.##.####",
                                          type: "text",
                                          placeholder: "00.00.0000",
                                          masked: true,
                                        },
                                        model: {
                                          value: _vm.period.end.input,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.period.end,
                                              "input",
                                              $$v
                                            )
                                          },
                                          expression: "period.end.input",
                                        },
                                      }),
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "c-input-container-period-input-icon",
                                        },
                                        [
                                          _c(
                                            "svg",
                                            {
                                              attrs: {
                                                width: "18",
                                                height: "18",
                                                viewBox: "0 0 18 18",
                                                fill: "none",
                                                xmlns:
                                                  "http://www.w3.org/2000/svg",
                                              },
                                            },
                                            [
                                              _c("path", {
                                                attrs: {
                                                  d: "M15.2222 3H2.77778C1.79594 3 1 3.69645 1 4.55556V15.4444C1 16.3036 1.79594 17 2.77778 17H15.2222C16.2041 17 17 16.3036 17 15.4444V4.55556C17 3.69645 16.2041 3 15.2222 3Z",
                                                  stroke: "#8E9CBB",
                                                  "stroke-width": "2",
                                                  "stroke-linecap": "round",
                                                  "stroke-linejoin": "round",
                                                },
                                              }),
                                              _c("path", {
                                                attrs: {
                                                  d: "M13 1V5",
                                                  stroke: "#8E9CBB",
                                                  "stroke-width": "2",
                                                  "stroke-linecap": "round",
                                                  "stroke-linejoin": "round",
                                                },
                                              }),
                                              _c("path", {
                                                attrs: {
                                                  d: "M5 1V5",
                                                  stroke: "#8E9CBB",
                                                  "stroke-width": "2",
                                                  "stroke-linecap": "round",
                                                  "stroke-linejoin": "round",
                                                },
                                              }),
                                              _c("rect", {
                                                attrs: {
                                                  x: "4",
                                                  y: "8",
                                                  width: "2",
                                                  height: "2",
                                                  fill: "#8E9CBB",
                                                },
                                              }),
                                              _c("rect", {
                                                attrs: {
                                                  x: "4",
                                                  y: "12",
                                                  width: "2",
                                                  height: "2",
                                                  fill: "#8E9CBB",
                                                },
                                              }),
                                              _c("rect", {
                                                attrs: {
                                                  x: "8",
                                                  y: "8",
                                                  width: "2",
                                                  height: "2",
                                                  fill: "#8E9CBB",
                                                },
                                              }),
                                              _c("rect", {
                                                attrs: {
                                                  x: "8",
                                                  y: "12",
                                                  width: "2",
                                                  height: "2",
                                                  fill: "#8E9CBB",
                                                },
                                              }),
                                              _c("rect", {
                                                attrs: {
                                                  x: "12",
                                                  y: "8",
                                                  width: "2",
                                                  height: "2",
                                                  fill: "#8E9CBB",
                                                },
                                              }),
                                              _c("rect", {
                                                attrs: {
                                                  x: "12",
                                                  y: "12",
                                                  width: "2",
                                                  height: "2",
                                                  fill: "#8E9CBB",
                                                },
                                              }),
                                            ]
                                          ),
                                        ]
                                      ),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "c-input-container-period-calendar",
                                    },
                                    [
                                      _c("datepicker", {
                                        attrs: {
                                          inline: true,
                                          language: _vm.ru,
                                          "full-month-name": true,
                                          "monday-first": true,
                                          highlighted: {
                                            from: _vm.period.start.highlighted,
                                            to: _vm.period.end.highlighted,
                                          },
                                          "open-date": _vm.period.endMonth,
                                          "calendar-class":
                                            "c-input-container-calendar c-input-container-calendar_period c-input-container-calendar_period-without-fixed-intervals",
                                        },
                                        on: {
                                          changedMonth: _vm.changedEndMonth,
                                          selected: _vm.periodSelectDay,
                                        },
                                        model: {
                                          value: _vm.period.end.selected,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.period.end,
                                              "selected",
                                              $$v
                                            )
                                          },
                                          expression: "period.end.selected",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ]
                              ),
                            ]
                          ),
                          _c(
                            "div",
                            {
                              staticClass: "c-input-container-period-switcher",
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "c-input-container-period-switcher-item",
                                  class: {
                                    "c-input-container-period-switcher-item_active":
                                      _vm.period.activeCalendar === "start",
                                  },
                                  on: {
                                    click: function ($event) {
                                      _vm.period.activeCalendar = "start"
                                    },
                                  },
                                },
                                [_c("span", [_vm._v("Начало периода")])]
                              ),
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "c-input-container-period-switcher-item",
                                  class: {
                                    "c-input-container-period-switcher-item_active":
                                      _vm.period.activeCalendar === "end",
                                  },
                                  on: {
                                    click: function ($event) {
                                      _vm.period.activeCalendar = "end"
                                    },
                                  },
                                },
                                [_c("span", [_vm._v("Конец периода")])]
                              ),
                            ]
                          ),
                          _c(
                            "div",
                            { staticClass: "c-input-container-period-right" },
                            [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "c-input-container-period-actions",
                                },
                                [
                                  _c("c-button", {
                                    staticClass:
                                      "c-input-container-period-action",
                                    attrs: {
                                      size: "small",
                                      label: "Применить",
                                      icon: { icon: "check", color: "success" },
                                    },
                                    on: { click: _vm.periodSubmit },
                                  }),
                                  _c("c-button", {
                                    staticClass:
                                      "c-input-container-period-action",
                                    attrs: {
                                      size: "small",
                                      label: "Сбросить",
                                      icon: {
                                        icon: "close",
                                        color: "secondary",
                                      },
                                    },
                                    on: { click: _vm.periodReset },
                                  }),
                                ],
                                1
                              ),
                            ]
                          ),
                        ]
                      )
                    : _vm._e(),
                ]
              )
            : _vm._e(),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }